import { useQuery } from "@tanstack/react-query";
import dateFormat from "dateformat";
import { useParams } from "react-router-dom";
import Footer from "../components/footer";
import Header from "../components/header";
import Spinner from "../components/spinner";
import TopNavabr from "../components/topNavabr";
import { BASE_URL } from "../data/baseURL";
import { useScrollTop } from "../hook/useScrollTop";

function ProjectDetails() {
  const { id } = useParams();
  const { data, isLoading, isError } = useQuery(
    [`projects-${id}`],
    async () => {
      const response = await window.fetch(`${BASE_URL}/project-details/${id}`);
      return await response.json();
    }
  );

  useScrollTop();

  if (isLoading) {
    return <Spinner />;
  }

  if (isError) {
    throw new Error("Unable to load data");
  }

  const {
    title,
    d_image,
    description,
    key_achievement,
    starting_date,
    end_date,
    status,
    project_category,
  } = data?.project;

  return (
    <>
      <TopNavabr />
      <Header imageURL={d_image}>
        <div className="py-5 my-5">
          <h1 className="fs-56 gilroy-bold text-center header-background-image-size">
            {title}
          </h1>
        </div>
      </Header>
      <section className="container-fluid py-5">
        <div className="ms-47 me-47">
          <p className="fs-16 text-white fw-700 text-capitalize d-inline-block">
            {status === "1" ? (
              <span className="badge text-bg-success px-3 py-2">Delivered</span>
            ) : status === "2" ? (
              <span className="badge text-bg-primary px-3 py-2">
                In-Progress
              </span>
            ) : (
              <span className="badge text-bg-warning px-3 py-2">Awarded</span>
            )}
          </p>
          {description && (
            <>
              <h2 className="fs-18 gilroy-bold my-3">Description</h2>
              <p
                className="fs-16 text-align-justify"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            </>
          )}
          {key_achievement && (
            <>
              <h2 className="fs-18 gilroy-bold mt-5 mb-3">Key Achievements</h2>
              <p
                className="fs-16 text-align-justify"
                dangerouslySetInnerHTML={{ __html: key_achievement }}
              />
            </>
          )}
          <h2 className="fs-18 mt-5">
            <span className="gilroy-bold">Project Duration :</span>{" "}
            <span className="fs-14">
              {starting_date && dateFormat(starting_date, "dS mmmm, yyyy")} -{" "}
              {end_date && dateFormat(end_date, "dS mmmm, yyyy")}
            </span>
          </h2>
          {project_category?.length > 0 && (
            <>
              <h2 className="fs-18 gilroy-bold mt-4">Project Category</h2>
              {project_category?.map((data, index) => (
                <>
                  <p className="fs-16">
                    {index + 1}. {data?.name}
                  </p>
                </>
              ))}
            </>
          )}
        </div>
      </section>
      <Footer />
    </>
  );
}

export default ProjectDetails;
